import React from 'react'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { CollateralBasketType } from 'api'
import { DialogRow } from 'view/components/inputs'
import { CollateralBasketPanelProps } from './CollateralBasketDialog'
import { CollateralBasketSelectedPermissionsGrid, CollateralBasketPermissionsGrid } from 'view/shared/collateralBasket'
import { allActiveTradingEntityDetailsSortedByOrganisationSelector, tradingEntityDetailsByIdsSortedSelector } from 'selectors'
import { Locale, Translation } from 'locale'
import { HorizontalLayout } from 'view/styles/constants'
import { useParametricSelector } from 'utils'

interface CollateralBasketPermissionsPanelProps extends CollateralBasketPanelProps {
  viewOnly: boolean
}

const Wrapper = styled.div`
  height: 430px;
  width: 500px;
`

const SelectboxWrapper = styled.div`
  height: 420px;
  width: 460px;
`

const CenterText = styled.div`
  text-align: center;
  margin-top: 200px;
`

export const CollateralBasketPermissionsPanel: React.FC<CollateralBasketPermissionsPanelProps> = props => {
  switch (props.collateralBasketProductSector?.basketType) {
    case CollateralBasketType.COLLATERAL:
      return <CenterText>{Locale.translate(Translation.SC_NO_PERMISSIONS_COLLATERAL)}</CenterText>
    case CollateralBasketType.CASH:
      return <CenterText>{Locale.translate(Translation.SC_NO_PERMISSIONS_CASH)}</CenterText>
    default:
      return <PermissionsPanel {...props} />
  }
}

const PermissionsPanel: React.FC<CollateralBasketPermissionsPanelProps> = ({ collateralBasket, onUpdate, viewOnly }) => {
  const allActiveTradingEntityDetails = useSelector(allActiveTradingEntityDetailsSortedByOrganisationSelector)
  const selectedCollateralBasketTradingEntityDetails = useParametricSelector(
    tradingEntityDetailsByIdsSortedSelector,
    collateralBasket.tradingEntityIds
  )

  const addTradingEntityId = (tradingEntityIds: string[]) => {
    const newTradingEntityIds = collateralBasket.tradingEntityIds
      ? [...new Set(collateralBasket.tradingEntityIds.concat(tradingEntityIds))]
      : tradingEntityIds
    onUpdate({ tradingEntityIds: newTradingEntityIds })
  }

  const removeTradingEntityId = (tradingEntityIds: string[]) => {
    const newTradingEntityIds = collateralBasket.tradingEntityIds.filter(id => !tradingEntityIds.includes(id))
    onUpdate({ tradingEntityIds: newTradingEntityIds })
  }

  const collateralBasketPermissionGridRowData = allActiveTradingEntityDetails.map(activeTradingEntityDetail => {
    return {
      ...activeTradingEntityDetail,
      selected: selectedCollateralBasketTradingEntityDetails.some(
        selectedTradingEntityDetail => selectedTradingEntityDetail.tradingEntity.id === activeTradingEntityDetail.tradingEntity.id
      )
    }
  })

  return (
    <>
      <DialogRow horizontalLayout={HorizontalLayout.SpaceBetween}>
        <Wrapper>
          <CollateralBasketPermissionsGrid
            rowData={collateralBasketPermissionGridRowData}
            addTradingEntityId={addTradingEntityId}
            removeTradingEntityId={removeTradingEntityId}
            viewOnly={viewOnly}
          />
        </Wrapper>
        {collateralBasket.tradingEntityIds && collateralBasket.tradingEntityIds.length > 0 && (
          <SelectboxWrapper>
            {Locale.translate(Translation.TC_SELECTED_ORGANISATIONS)} ({collateralBasket.tradingEntityIds.length})
            <CollateralBasketSelectedPermissionsGrid
              rowData={selectedCollateralBasketTradingEntityDetails}
              onRemoveTradingEntityId={removeTradingEntityId}
              viewOnly={viewOnly}
            />
          </SelectboxWrapper>
        )}
      </DialogRow>
    </>
  )
}
